import React, { useMemo, type ComponentPropsWithoutRef } from 'react';

import classnames from 'classnames';

import { ExtraSmall } from 'styled-system';

import styles from './Tag.module.scss';

export type TagProps = {
    className?: string;
    text?: string;
    color?: string;
    onClick?: () => void;
} & ComponentPropsWithoutRef<'span'>;

export const Tag = ({ className, text, color, onClick, style, ...rest }: TagProps) => {
    const backgroundColor = color || 'var(--color-layout-surface-primary-default)';
    const renderedText = useMemo(() => {
        if (text === undefined) {
            return '-';
        }
        if (!text) {
            // We need to return a zero width space character here to prevent the tag from collapsing
            return '\u200B';
        }
        return text;
    }, [text]);

    return (
        <span
            style={{ backgroundColor, ...style }}
            className={classnames(className, styles.tag)}
            onClick={onClick}
            {...rest}
        >
            <ExtraSmall
                className={classnames('notranslate', styles.tooltip)}
                truncate
                tooltip={text}
            >
                {renderedText}
            </ExtraSmall>
        </span>
    );
};

Tag.displayName = 'Tag';
